module.exports = __webpack_public_path__ + "static/media/bg_icon_4.10fe6836.svg";